import { FunctionFactory } from 'survey-core';
import { Goals } from '../quiz/goals';
import { tSurvey } from '../i18n/survey';
import { locHtml } from './locHtml';
import { makeSplashHeader } from './SplashHeader';

const goodHandsHtml = locHtml((t) => `
<div class="new-quote-container centered">
  <div class="splash-icon">💪</div>
  <div class="splash-header">
    <h1>${t("splash.goodHands.title")}</h1>
    <div class="quote">
      {goodHandsGoalText}
    </div>
  </div>
</div>`);

const goodHandsSplashElement = {
  name: 'good-hands-splash',
  type: 'html',
  html: goodHandsHtml,
}

// The whole sentence per goal ("110,247 people have lost weight with ..."), so
// Spanish can word it naturally; the html shows it as {goodHandsGoalText}.
function renderGoodHandsGoalsText(params: any[]): string {
  if (params === undefined || params === null) return "";
  switch (params[0] as Goals) {
    case Goals.LoseFat:
      return tSurvey("splash.goodHands.text.loseWeight");
    case Goals.BuildMuscle:
      return tSurvey("splash.goodHands.text.buildMuscle");
    case Goals.BuildMuscleAndLoseFat:
      return tSurvey("splash.goodHands.text.recomp");
  }
}

const goodHandsGoalsTextExpression = {
  name: "goodHandsGoalText",
  expression: "renderGoodHandsGoalsText({goals})",
};

FunctionFactory.Instance.register("renderGoodHandsGoalsText", renderGoodHandsGoalsText);

const GoodHandsSplashHeader = makeSplashHeader("splash.headers.goodHands");

export {
  goodHandsSplashElement,
  goodHandsGoalsTextExpression,
  GoodHandsSplashHeader,
}
